import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useContentNudgeQuery, { CONTENT_NUDGES_PER_PAGE } from 'actions/nudges/useContentNudgeQuery';
import useSearchParams from 'hooks/useSearchParams';
import { locationWithPageNumber, getNumberOfPages, getPageFromQuery } from 'utils/pagination';
import Text from 'components/Text';
import TableCard, { Column } from 'components/TableCard';
import { AdminOrHubTextLink } from 'components/AdminOrHubLink';
import NudgeAudience from './NudgeAudience';
import NudgeDates from './NudgeDates';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NudgesTable(_ref) {
  var contentId = _ref.contentId,
    type = _ref.type;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var page = getPageFromQuery({
    query: searchParams,
    pageQueryParameter: 'content_nudges_page'
  });
  var _useContentNudgeQuery = useContentNudgeQuery({
      contentId: contentId,
      page: page
    }),
    items = _useContentNudgeQuery.items,
    total = _useContentNudgeQuery.total;
  var pageCount = getNumberOfPages({
    total: total,
    itemsPerPage: CONTENT_NUDGES_PER_PAGE
  });
  if (!items.length) {
    return /*#__PURE__*/_jsx(Text, {
      children: t('content_nudges_card_empty_state', {
        context: type
      })
    });
  }
  return /*#__PURE__*/_jsxs(TableCard, {
    data: items,
    pageCount: pageCount,
    currentPage: page,
    getPageLink: function getPageLink(pageNumber) {
      return locationWithPageNumber({
        location: location,
        page: pageNumber,
        pageQueryParameter: 'content_nudges_page'
      });
    },
    mobileViewBreakpoint: "l",
    align: "top",
    children: [/*#__PURE__*/_jsx(Column, {
      title: t('property_name'),
      cellRenderer: function cellRenderer(nudge) {
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(AdminOrHubTextLink, {
            link: "/nudges/".concat(nudge.id),
            children: /*#__PURE__*/_jsx(Text, {
              bold: true,
              children: nudge.name
            })
          }), !nudge.isEnabled && /*#__PURE__*/_jsx(Text, {
            as: "div",
            dimmed: true,
            children: t('state_disabled')
          })]
        });
      }
    }), /*#__PURE__*/_jsx(Column, {
      title: t('nudge_goal_title'),
      cellRenderer: function cellRenderer(nudge) {
        var goal = nudge.goalType === 'completeContent' ? 'state_complete_content' : 'state_open_content';
        return /*#__PURE__*/_jsx(Text, {
          children: t(goal)
        });
      }
    }), /*#__PURE__*/_jsx(Column, {
      title: t('property_dates'),
      cellRenderer: function cellRenderer(nudge) {
        return /*#__PURE__*/_jsx(NudgeDates, {
          nudge: nudge
        });
      }
    }), /*#__PURE__*/_jsx(Column, {
      title: t('property_audience'),
      cellRenderer: function cellRenderer(nudge) {
        var audience = nudge.audience,
          nudgeTeamsIds = nudge.nudgeTeamsIds;
        return /*#__PURE__*/_jsx(NudgeAudience, {
          audience: audience,
          teamIds: nudgeTeamsIds
        });
      }
    })]
  });
}
export default NudgesTable;